var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarDs = function SvgCalendarDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87:9306)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0781,
    cy: 10.2031,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.875 3.5625H17.8594V2.78125C17.8594 2.34977 17.5096 2 17.0781 2C16.6466 2 16.2969 2.34977 16.2969 2.78125V3.5625H12.7422V2.78125C12.7422 2.34977 12.3924 2 11.9609 2C11.5295 2 11.1797 2.34977 11.1797 2.78125V3.5625H7.66406V2.78125C7.66406 2.34977 7.3143 2 6.88281 2C6.45133 2 6.10156 2.34977 6.10156 2.78125V3.5625H5.125C3.40188 3.5625 2 4.96438 2 6.6875V18.875C2 20.5981 3.40188 22 5.125 22H11.1016C11.533 22 11.8828 21.6502 11.8828 21.2188C11.8828 20.7873 11.533 20.4375 11.1016 20.4375H5.125C4.26344 20.4375 3.5625 19.7366 3.5625 18.875V6.6875C3.5625 5.82594 4.26344 5.125 5.125 5.125H6.10156V5.90625C6.10156 6.33773 6.45133 6.6875 6.88281 6.6875C7.3143 6.6875 7.66406 6.33773 7.66406 5.90625V5.125H11.1797V5.90625C11.1797 6.33773 11.5295 6.6875 11.9609 6.6875C12.3924 6.6875 12.7422 6.33773 12.7422 5.90625V5.125H16.2969V5.90625C16.2969 6.33773 16.6466 6.6875 17.0781 6.6875C17.5096 6.6875 17.8594 6.33773 17.8594 5.90625V5.125H18.875C19.7366 5.125 20.4375 5.82594 20.4375 6.6875V11.1406C20.4375 11.5721 20.7873 11.9219 21.2188 11.9219C21.6502 11.9219 22 11.5721 22 11.1406V6.6875C22 4.96438 20.5981 3.5625 18.875 3.5625Z",
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5469 17.2734C12.5469 14.6672 14.6672 12.5469 17.2734 12.5469C19.8797 12.5469 22 14.6672 22 17.2734C22 19.8797 19.8797 22 17.2734 22C14.6672 22 12.5469 19.8797 12.5469 17.2734ZM14.1094 17.2734C14.1094 19.0181 15.5288 20.4375 17.2734 20.4375C19.0181 20.4375 20.4375 19.0181 20.4375 17.2734C20.4375 15.5287 19.0181 14.1094 17.2734 14.1094C15.5288 14.1094 14.1094 15.5287 14.1094 17.2734Z",
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4062 16.4922H18.0547V15.6719C18.0547 15.2404 17.7049 14.8906 17.2734 14.8906C16.842 14.8906 16.4922 15.2404 16.4922 15.6719V17.2734C16.4922 17.7049 16.842 18.0547 17.2734 18.0547H18.4062C18.8377 18.0547 19.1875 17.7049 19.1875 17.2734C19.1875 16.842 18.8377 16.4922 18.4062 16.4922Z",
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6797,
    cy: 10.2031,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.2812,
    cy: 13.6016,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.88281,
    cy: 10.2031,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.88281,
    cy: 13.6016,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.88281,
    cy: 17,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.2812,
    cy: 17,
    r: 0.78125,
    fill: "#9496A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.2812,
    cy: 10.2031,
    r: 0.78125,
    fill: "#9496A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87:9306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Calendar-ds.93cca1a9ae7d7435a84757c8d34576d6.svg";